import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { subscribe } from 'alfa';

import UserLoader from './user';
import BusinessLoader from './business';
import Security from '../../helpers/security';
import KeyCreator from '../key/create';

const Session = ({ location: { pathname }, ...props }) => {
  const isLoginPath = () => pathname === '/login' || pathname === '/login/confirm';

  const needsLogin = () => !Security.getToken();

  if (isLoginPath() || needsLogin()) {
    return props.children;
  }

  return (
    <UserLoader>
      <KeyCreator />
      <BusinessLoader>{props.children}</BusinessLoader>
    </UserLoader>
  );
};

Session.propTypes = {
  children: PropTypes.any,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

export default withRouter(subscribe(Session, ['user']));
